import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteFillOpblack30Shadow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M4.293 12.849c.948 1.12 6.91 6.959 7.71 7.651.801-.692 6.754-6.53 7.703-7.651.902-.998 1.566-2.246 1.566-3.697a5.152 5.152 0 0 0-9.273-3.092 5.152 5.152 0 0 0-9.273 3.092c0 1.45.665 2.7 1.567 3.697"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.523 8.902a4.403 4.403 0 0 0-7.924-2.641l-.44.585a.2.2 0 0 1-.32 0l-.44-.585a4.403 4.403 0 0 0-7.923 2.642c0 1.208.553 2.285 1.373 3.193l.008.008.008.01c.447.528 2.143 2.238 3.865 3.937 1.297 1.28 2.568 2.51 3.274 3.178.705-.668 1.973-1.898 3.269-3.177 1.72-1.7 3.414-3.41 3.86-3.938l.009-.01.007-.008c.82-.908 1.373-1.985 1.374-3.194m1.5 0c0 1.693-.778 3.112-1.76 4.2l-.001-.001c-.522.61-2.259 2.36-3.936 4.017-1.698 1.677-3.407 3.333-3.83 3.7a.75.75 0 0 1-.983 0c-.424-.367-2.136-2.021-3.836-3.699-1.696-1.673-3.455-3.443-3.957-4.036-.975-1.085-1.743-2.498-1.743-4.18A5.903 5.903 0 0 1 7.879 3c1.604 0 3.057.642 4.12 1.68A5.88 5.88 0 0 1 16.12 3a5.903 5.903 0 0 1 5.903 5.902"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 24.545,
    height: 22.5,
    x: -0.273,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85682_21706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_85682_21706",
    result: "effect2_dropShadow_85682_21706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_85682_21706",
    result: "shape"
  }))));
}
var IcFavoriteFillOpblack30shadow = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteFillOpblack30Shadow));

export { IcFavoriteFillOpblack30shadow as I };
